import React, { useState } from 'react';
import './MenuPage.css';
import foodMenuBackground from '../assets/optimized/food-menu.webp';
import beerMenuBackground from '../assets/optimized/beer-menu.webp';
import drinksMenuBackground from '../assets/optimized/drinks-menu.webp';
import starterVegBackground from '../assets/optimized/starter-veg.webp';
import starterNonVegBackground from '../assets/optimized/starter-nonveg.webp';
import mainCourseVegBackground from '../assets/optimized/maincourse-veg.webp';
import mainCourseNonVegBackground from '../assets/optimized/maincourse-nonveg.webp';
import beerBrewBackground from '../assets/optimized/beer-brew.webp';
import boldBeerBackground from '../assets/optimized/beer.webp';
import cocktailsBackground from '../assets/optimized/cocktails.webp';
import wineBackground from '../assets/optimized/wine.webp';
import spiritsBackground from '../assets/optimized/spirits.webp';
import zeroSpiritDrinkBackground from '../assets/optimized/zero-spirit-drink.webp';

const menuChoices = [
  {
    key: 'food',
    title: 'Food Menu',
    eyebrow: 'Kitchen',
    desc: 'Starters, main course plates and desserts from the Wild Elephant kitchen.',
  },
  {
    key: 'beer',
    title: 'Beer Menu',
    eyebrow: 'Brewery',
    desc: 'House brews, bold beers, flights and seasonal craft pours.',
  },
  {
    key: 'drinks',
    title: 'Drinks Menu',
    eyebrow: 'Bar',
    desc: 'Cocktails, wines, spirits, highballs and zero-proof drinks.',
  },
];

const menus = {
  food: {
    title: 'Food Menu',
    sections: [
      {
        title: 'Starters - Veg',
        backgroundImage: starterVegBackground,
        items: [
          ['Smoked Corn Tikkis', 'Sweet corn, cheddar, jalapeno, sriracha mayo', 'Rs 280'],
          ['Truffle Mushroom Galouti', 'Charred mushrooms, cashew cream, crisp roomali', 'Rs 340'],
          ['Paneer Pepper Fry', 'Cottage cheese, curry leaf, crushed pepper', 'Rs 320'],
          ['Beer-Battered Onion Rings', 'House IPA batter, chipotle dip, parmesan dust', 'Rs 220'],
        ],
      },
      {
        title: 'Starters - Non Veg',
        backgroundImage: starterNonVegBackground,
        items: [
          ['Chicken Ghee Roast Bites', 'Mangalorean spice, neer dosa crisps', 'Rs 380'],
          ['Burnt Butter Prawns', 'Tiger prawns, mango-habanero glaze, charred lime', 'Rs 680'],
          ['Lamb Seekh Skewers', 'Saffron aioli, pickled onion, mint dust', 'Rs 420'],
          ['Calamari al Carbon', 'Grilled squid, chilli-garlic butter, crispy capers', 'Rs 320'],
        ],
      },
      {
        title: 'Main Course - Veg',
        backgroundImage: mainCourseVegBackground,
        items: [
          ['Jackfruit Sheekh Platter', 'Charcoal jackfruit, cashew cream, mint chutney', 'Rs 460'],
          ['Wild Paneer Biryani', 'Saffron rice, smoked butter, raita, shorba', 'Rs 480'],
          ['Mushroom Pepper Kulcha Bowl', 'Malabar pepper sauce, butter kulcha', 'Rs 440'],
          ['Elephant Walk Pizza', 'Tandoori sauce, vegetables, feta, coriander oil', 'Rs 520'],
        ],
      },
      {
        title: 'Main Course - Non Veg',
        backgroundImage: mainCourseNonVegBackground,
        items: [
          ['Wild Elephant Biryani', 'Slow-cooked handi biryani, raita, shorba', 'Rs 520'],
          ['Lamb Chops Chimichurri', 'Grilled lamb, corn polenta, roasted roots', 'Rs 860'],
          ['Whole Grilled Basa', 'Konkan coconut chutney, pickled mango, rice', 'Rs 620'],
          ['Wagyu Burger', 'Aged cheddar, beer-braised onion jam, brioche', 'Rs 780'],
        ],
      },
      {
        title: 'Desserts',
        items: [
          ['Stout Chocolate Lava', 'Dark fondant, stout reduction, vanilla gelato', 'Rs 280'],
          ['Saffron Panna Cotta', 'Rose gel, pistachio brittle, cardamom cream', 'Rs 240'],
          ['Mango Sticky Rice', 'Coconut cream, sesame toffee, Alphonso mango', 'Rs 220'],
          ['Cheese Board', 'Artisan cheeses, preserves, honeycomb, crackers', 'Rs 480'],
        ],
      },
    ],
  },
  beer: {
    title: 'Beer Menu',
    sections: [
      {
        title: 'House Brews',
        backgroundImage: beerBrewBackground,
        backgroundPosition: 'center 75%',
        items: [
          ['Tusker Gold Lager', 'Clean, crisp, lightly floral', 'Pint Rs 280'],
          ['Mysuru Amber Ale', 'Caramel malt, balanced hops, sunset copper', 'Pint Rs 320'],
          ['Midnight Stampede Stout', 'Coffee, cacao, roasted barley', 'Pint Rs 340'],
          ['Spiced Wheat', 'Coriander, orange zest, gentle clove', 'Pint Rs 300'],
        ],
      },
      {
        title: 'Bold Beers',
        backgroundImage: boldBeerBackground,
        items: [
          ['Jungle Haze IPA', 'Tropical hops, citrus peel, soft bitterness', 'Pint Rs 360'],
          ['Seasonal Sour', 'Tart fruit, lively bubbles, rotating batch', 'Pint Rs 350'],
          ['Barrel-Aged Porter', 'Oak, cocoa nib, vanilla warmth', 'Pint Rs 390'],
          ['Double IPA', 'Pine, mango, firm bitter finish', 'Pint Rs 420'],
        ],
      },
      {
        title: 'Beer Flights',
        items: [
          ['Wild Sampler', 'Four 150ml pours chosen by the brewer', 'Rs 520'],
          ['Malt Trail', 'Amber, stout, seasonal dark ale', 'Rs 560'],
          ['Hop Trail', 'IPA, pale ale, seasonal hop release', 'Rs 580'],
          ['Brewmaster Flight', 'Six pours with tasting notes', 'Rs 760'],
        ],
      },
    ],
  },
  drinks: {
    title: 'Drinks Menu',
    sections: [
      {
        title: 'Cocktails',
        backgroundImage: cocktailsBackground,
        items: [
          ['Elephant Old Fashioned', 'Bourbon, jaggery, bitters, orange oil', 'Rs 520'],
          ['Jungle Bird', 'Dark rum, pineapple, Campari, lime', 'Rs 480'],
          ['Mysuru Mule', 'Vodka, ginger, lime, curry leaf', 'Rs 420'],
          ['Smoked Negroni', 'Gin, Campari, vermouth, orange smoke', 'Rs 540'],
        ],
      },
      {
        title: 'Wines',
        backgroundImage: wineBackground,
        items: [
          ['Sauvignon Blanc', 'Crisp citrus, green apple', 'Glass Rs 440'],
          ['Shiraz Reserve', 'Plum, spice, smooth tannins', 'Glass Rs 520'],
          ['Sparkling Brut', 'Dry, bright, celebratory bubbles', 'Glass Rs 560'],
          ['Rose', 'Strawberry, melon, clean finish', 'Glass Rs 480'],
        ],
      },
      {
        title: 'Spirits',
        backgroundImage: spiritsBackground,
        items: [
          ['Single Malt Pour', 'Rotating premium selection', 'From Rs 620'],
          ['Gin & Botanical Tonic', 'House tonic, cucumber, basil', 'Rs 460'],
          ['Aged Rum Pour', 'Vanilla, spice, toasted sugar', 'Rs 520'],
          ['Tequila Highball', 'Agave, grapefruit, soda', 'Rs 480'],
        ],
      },
      {
        title: 'Zero Proof',
        backgroundImage: zeroSpiritDrinkBackground,
        items: [
          ['Kokum Fizz', 'Kokum, lime, soda, mint', 'Rs 220'],
          ['Mango Basil Cooler', 'Mango, basil, citrus, tonic', 'Rs 240'],
          ['Spiced Ginger Spritz', 'Ginger, orange, pepper, soda', 'Rs 220'],
          ['Cold Brew Tonic', 'Coffee, tonic, orange peel', 'Rs 260'],
        ],
      },
    ],
  },
};

export default function MenuPage() {
  const [activeMenu, setActiveMenu] = useState(null);
  const [activeSection, setActiveSection] = useState(0);
  const selected = activeMenu ? menus[activeMenu] : null;

  const openMenu = (key) => {
    setActiveMenu(key);
    setActiveSection(0);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const getChoiceStyle = (choice, index) => {
    const style = { animationDelay: `${index * 0.12}s` };
    if (choice.key === 'food') {
      style['--choice-bg-image'] = `url("${foodMenuBackground}")`;
    }
    if (choice.key === 'beer') {
      style['--choice-bg-image'] = `url("${beerMenuBackground}")`;
    }
    if (choice.key === 'drinks') {
      style['--choice-bg-image'] = `url("${drinksMenuBackground}")`;
    }
    return style;
  };

  if (!selected) {
    return (
      <main className="menu-page">
        <div className="menu-page__lines" />
        <section className="menu-page__hero menu-page__hero--center">
          <div className="menu-page__eyebrow">Wild Elephant Menus</div>
          <h1>Menu</h1>
          <p>Select a menu to view category-wise items.</p>
        </section>

        <section className="menu-page__choice-grid">
          {menuChoices.map((choice, index) => (
          <button
              key={choice.key}
              className={`menu-page__choice ${choice.key === 'food' ? 'menu-page__choice--food' : ''} ${choice.key === 'beer' ? 'menu-page__choice--beer' : ''} ${choice.key === 'drinks' ? 'menu-page__choice--drinks' : ''}`}
              style={getChoiceStyle(choice, index)}
              onClick={() => openMenu(choice.key)}
            >
              <span>{choice.eyebrow}</span>
              <strong>{choice.title}</strong>
              <p>View menu</p>
            </button>
          ))}
        </section>
      </main>
    );
  }

  const section = selected.sections[activeSection];
  const showPrices = activeMenu === 'drinks' && section.title !== 'Cocktails';
  const sectionStyle = section.backgroundImage
    ? {
        '--section-bg-image': `url("${section.backgroundImage}")`,
        '--section-bg-position': section.backgroundPosition || 'center center',
      }
    : undefined;

  return (
    <main className={`menu-page menu-page--detail ${activeMenu === 'food' ? 'menu-page--food-detail' : ''}`}>
      <div className="menu-page__lines" />
      <section className="menu-page__detail-shell">
        <div className="menu-page__detail-head">
          <button className="menu-page__back" onClick={() => setActiveMenu(null)}>
            Back
          </button>
          <div>
            <div className="menu-page__eyebrow">Wild Elephant</div>
            <h1>{selected.title}</h1>
          </div>
        </div>

        <div className="menu-page__detail-layout">
          <aside className="menu-page__category-nav">
            {selected.sections.map((item, index) => (
              <button
                key={item.title}
                className={`menu-page__category-btn ${activeSection === index ? 'menu-page__category-btn--active' : ''}`}
                style={{ '--category-delay': `${index * 0.08}s` }}
                onClick={() => setActiveSection(index)}
              >
                {item.title}
              </button>
            ))}
          </aside>

          <article
            className={`menu-page__scroll-card ${section.backgroundImage ? 'menu-page__scroll-card--image' : ''}`}
            key={`${activeMenu}-${section.title}`}
            style={sectionStyle}
          >
            <div className="menu-page__card-heading">
              <span>{section.title}</span>
            </div>
            <div className="menu-page__scroll-items">
              {section.items.map(([name, desc, price], index) => (
                <div
                  className={`menu-page__item ${showPrices ? '' : 'menu-page__item--no-price'}`}
                  key={name}
                  style={{ '--item-delay': `${index * 0.09}s` }}
                >
                  <div>
                    <h3>{name}</h3>
                    <p>{desc}</p>
                  </div>
                  {showPrices ? <strong>{price}</strong> : null}
                </div>
              ))}
            </div>
          </article>
        </div>
      </section>
    </main>
  );
}
